module.exports = __webpack_public_path__ + "img/14.50aa5a02.jpg";